/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-17",
    versionChannel: "nightly",
    buildDate: "2025-04-17T00:06:51.235Z",
    commitHash: "83744bcb37291f2bd2070959d12a78c15d5c47c3",
};
